/* eslint-disable react/jsx-props-no-spreading */
import { paths } from 'constants/paths';
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import { EnhancedRouteConfig } from 'utils/router';
// import { FormattedMessage } from 'react-intl';
import { SystemSettingLine, ShareFormatLine, ShareOperationrecordLine } from '@m-ui/icons';

const Home = lazy(async () => import(/* webpackChunkName: 'Home' */ 'page/Home'));

const Personal = lazy(async () => import(/* webpackChunkName: 'Personal' */ 'page/Personal'));

const Inspiration = lazy(async () => import(/* webpackChunkName: 'Inspiration' */ 'page/Inspiration'));
const PopularAds = lazy(
    async () => import(/* webpackChunkName: 'Inspiration/PopularAds' */ 'page/Inspiration/PopularAds'),
);
const CreativeStrategy = lazy(
    async () => import(/* webpackChunkName: 'Inspiration/PopularAds' */ 'page/Inspiration/CreativeStrategy'),
);
const CreativeTool = lazy(async () => import(/* webpackChunkName: 'CreativeTool' */ 'page/CreativeTool'));
const CreativePurchasing = lazy(
    async () => import(/* webpackChunkName: 'CreativePurchasing' */ 'page/CreativePurchasing'),
);

const ExcitingVideo = lazy(
    async () => import(/* webpackChunkName: 'Inspiration/ExcitingVideo' */ 'page/Inspiration/ExcitingVideo'),
);
const Trending = lazy(async () => import(/* webpackChunkName: 'Trending' */ 'page/Trending'));
const Creator = lazy(async () => import(/* webpackChunkName: 'Trending/Creator' */ 'page/Trending/Creator'));
const Music = lazy(async () => import(/* webpackChunkName: 'Trending/Music' */ 'page/Trending/Music'));
const HashTags = lazy(async () => import(/* webpackChunkName: 'Trending/HashTags' */ 'page/Trending/HashTags'));

const InfoDetail = lazy(async () => import(/* webpackChunkName: 'InfoDetail' */ 'page/InfoDetail'));
const CreatorDetail = lazy(
    async () => import(/* webpackChunkName: 'InfoDetail/CreatorDetail' */ 'page/InfoDetail/CreatorDetail'),
);
const HashTagDetail = lazy(async () => import(/* webpackChunkName: 'HashTagDetail' */ 'page/InfoDetail/HashTagDetail'));
const MusicDetail = lazy(
    async () => import(/* webpackChunkName: 'InfoDetail/MusicDetail' */ 'page/InfoDetail/MusicDetail'),
);
const VideoDetail = lazy(
    async () => import(/* webpackChunkName: 'InfoDetail/VideoDetail' */ 'page/InfoDetail/VideoDetail'),
);
const AdDetail = lazy(async () => import(/* webpackChunkName: 'InfoDetail/AdDetail' */ 'page/InfoDetail/AdDetail'));

function useRoutes(): EnhancedRouteConfig[] | undefined {
    const routes = [
        {
            path: paths.BASE.path,
            exact: true,
            title: null,
            // strict: true,
            component: () => {
                return <Redirect from={paths.BASE.path} to={paths.HOME.path} />;
            },
        },
        {
            path: paths.HOME.path,
            exact: true,
            title: 'Home',
            component: () => <Home />,
        },
        {
            path: paths.TRENDING.path,
            component: Trending,
            title: 'Trends',
            icon: <SystemSettingLine />,
            routes: [
                {
                    path: paths.TRENDING.routes.HASHTAGS.path,
                    title: 'Hashtags',
                    icon: <ShareOperationrecordLine />,
                    component: HashTags,
                },
                {
                    path: paths.TRENDING.routes.MUSIC.path,
                    title: 'Songs',
                    icon: <ShareOperationrecordLine />,
                    component: Music,
                },
                {
                    path: paths.TRENDING.routes.CREATOR.path,
                    title: 'Creators',
                    icon: <ShareOperationrecordLine />,
                    component: Creator,
                },
            ],
        },
        {
            path: paths.CREATIVEPURCHASING.path,
            exact: true,
            title: 'Creative Purchasing',
            component: CreativePurchasing,
        },
        // {
        //     path: paths.CRETIVETOOL.path,
        //     exact: true,
        //     title: 'Creative Tools',
        //     component: CreativeTool,
        // },
        // {
        //     path: paths.ExcitingVideo.path,
        //     exact: true,
        //     title: <FormattedMessage defaultMessage="ExcitingVideo" />,
        //     component: ExcitingVideo,
        // },
        {
            path: paths.INSPIRATION.path,
            component: Inspiration,
            title: 'Creative Creation',
            icon: <SystemSettingLine />,
            routes: [
                {
                    path: paths.INSPIRATION.routes.POPULARADS.path,
                    title: 'PopularAds',
                    icon: <ShareOperationrecordLine />,
                    component: PopularAds,
                },
                {
                    path: paths.INSPIRATION.routes.CREATIVESTRATEGY.path,
                    title: 'CreativeStrategy',
                    icon: <ShareFormatLine />,
                    component: CreativeStrategy,
                },
                {
                    path: paths.INSPIRATION.routes.ExcitingVideo.path,
                    title: 'Top Videos',
                    icon: <ShareFormatLine />,
                    component: ExcitingVideo,
                },
            ],
        },
        {
            path: paths.INFODETAIL.path,
            component: InfoDetail,
            title: 'InfoDetail',
            icon: <SystemSettingLine />,
            routes: [
                {
                    path: paths.INFODETAIL.routes.CREATORDETAIL.path,
                    title: 'CreatorDetail',
                    icon: <ShareOperationrecordLine />,
                    component: CreatorDetail,
                },
                {
                    path: paths.INFODETAIL.routes.HASHTAGDETAIL.path,
                    title: 'HashTagDetail',
                    icon: <ShareOperationrecordLine />,
                    component: HashTagDetail,
                },
                {
                    path: paths.INFODETAIL.routes.MUSICDETAIL.path,
                    title: 'MusicDetail',
                    icon: <ShareOperationrecordLine />,
                    component: MusicDetail,
                },
                {
                    path: paths.INFODETAIL.routes.VIDEODETAIL.path,
                    title: 'VideoDetail',
                    icon: <ShareOperationrecordLine />,
                    component: VideoDetail,
                },
                {
                    path: paths.INFODETAIL.routes.ADDETAIL.path,
                    title: 'AdDetail',
                    icon: <ShareOperationrecordLine />,
                    component: AdDetail,
                },
            ],
        },
        {
            path: paths.PERSONAL.path,
            component: Personal,
            title: 'Personal',
        },
        {
            path: '*',
            exact: true,
            title: null,
            component: () => {
                return <Redirect from={paths.BASE.path} to={paths.HOME.path} />;
            },
        },
    ];
    return routes;
}

export { useRoutes };
